export function Breakpoint(breakpoint) {
    const mql = window.matchMedia(breakpoint);

    let isActive = mql.matches;

    let cbs = [];
    const handler = (e) => {
        isActive = e.matches;
        cbs.forEach((cb) => cb(isActive));
    };
    mql.addEventListener("change", handler);


    return {
        subscribe(cb) {
            cb(isActive);
            cbs.push(cb);
        },
        unsubscribe(cb) {
            cbs = cbs.filter((fn) => fn !== cb);
        },
        dispose() {
            cbs = [];
            mql.removeEventListener("change", handler);
        },
    };
}
